import { InjectionToken } from '@angular/core';

/**
 * Injection token for the Connect portal base URL.
 * The URL varies per environment
 */
export const CONNECT_PORTAL_URL = new InjectionToken<string>('CONNECT_PORTAL_URL');
